import { SupabaseClient } from "@supabase/supabase-js";

/**
 * Checks if a user with the given phone number already exists in our users database
 *
 * @param {SupabaseClient} supabase - the Supabase client for the existing session
 * @param {string} phone - The phone number to check for an existing user.
 * @returns {Promise<boolean>} - A promise that resolves to `true` if the user exists, or `false` otherwise.
 */
export const checkPhoneExists = async (
  supabase: SupabaseClient,
  phone: string
) => {
  try {
    const { data, error } = await supabase.rpc("check_phone_exists", {
      phone_number: phone,
    });
    if (error) throw error;
    return data;
  } catch (err) {
    console.error("Error checking phone:", err);
    return false;
  }
};
